import React from "react";
// plugin that creates slider
import Slider from "nouislider";
// @material-ui/core components
import { makeStyles, withStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Box from '@material-ui/core/Box';
import Avatar from '@material-ui/core/Avatar';
// @material-ui/icons
import Paper from '@material-ui/core/Paper';
// core components
import NativeSelect from '@material-ui/core/NativeSelect';
import http from "../http";
import moment from "moment";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { useDropzone } from "react-dropzone";
import icon from "../assets/img/icon.png";
import Swal from 'sweetalert2'
import useForm  from "./useForm";
import {sum} from "lodash";
import * as DocHelpers from "../Helpers/documentsHelper";


const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
  },
  bar: {
    borderRadius: 5,
    backgroundColor: '#1a90ff',
  }
}))(LinearProgress);




const premiumAmounts = ['R3 000' ,'R4 000','R5 000','R7 000','R10 000', 'R20 000']

const Premiums = [
  {
    key: 1,
    name: 'Individual who is single with or without children in age group  (14-65 years) inclusive',
    prices:[35 ,39,40,45,54, 100],
    min: 14,
    max: 65,
  },
  {
    key: 2,
    name: 'Individual who is single with or without children in age group (66-74 years) inclusive',
    prices:[55 ,65,70,85,102, 188],
    min: 66,
    max: 74,
  },
  {
    key: 3,
    name: 'Family cover in age group (14-65 years). Husband, Wife & Kids cover in age group (14-65 years) Kids below age of 21 years or 26 years if still at school',
    prices:[38 ,42,45,50,63, 108],
    min: 14,
    max: 65,
  },
  {
    key: 4,
    name: 'Family cover in age group (66-74 years). Husband & Wife cover in age group (66-74 years)',
    prices:[67 ,81,98,123,163, 310],
    min: 66,
    max: 74,
  },
  {
    key: 5,
    name: 'Individual / Old Age (75-84 years). Individual Person whose age is from 75yrs to 85yrs (inclusive)',
    prices:[80 ,96,112,138,185],
    min: 75,
    max: 84,
  },
  {
    key: 6,
    name: 'Individual without children (85-90 years). Individual Person whose age is from 86yrs to 90yrs (inclusive)',
    prices:[119,148,175,230,315],
    min: 85,
    max: 90,
  },
  {
    key: 7,
    name: 'Extended Family Children (0-13). Extended Family Children whose age is from 0yrs to 13yrs (inclusive)',
    prices:[30,35,40],
    min: 0,
    max: 13,
  },

]

const styles = {
  textCenter: {
    textAlign: "center"
  },
  textMuted: {
    backgroundColor: "green"
  },
  tablehead: {
    backgroundColor:'#DD342F',
    color: 'white',
  },
  table:{
    color: 'white',
    fontSize:13,
    borderRight: '1px solid black'
  },
  table2:{
    color:'black',
    borderRight: '1px solid black'
  }

};
const musicDropStyle = {
  fontWeight: 'bold',
  border: 4,
  borderColor: 'ghostwhite',
  backgroundColor: 'rgb(35,48,79)',
  padding: 30,
  color:'ghostwhite'
}
const useStyles = makeStyles(styles);
const filesize = require('filesize');
export default function NewPolicy(props) {
 const [loading, setLoading] = React.useState(false);
 const classes = useStyles();
 const nth = function(d) {
  if (d > 3 && d < 21) return 'th';
  switch (d % 10) {
    case 1:  return "st";
    case 2:  return "nd";
    case 3:  return "rd";
    default: return "th";
  }
}


const fortnightAway = new Date();
const date = fortnightAway.getDate();
const month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][fortnightAway.getMonth()];
const [mainCoverList, setMainCoverList] = React.useState(null);
const [mainCoverList2, setMainCoverList2] = React.useState(null);
const { form: music, setForm, setInForm } = useForm({
        fileSize:'',
        fileName:'',
        signedAt: 'Nrand Website',
        sgnedDay: date + nth(date),
        signedmonth: month+' '+fortnightAway.getFullYear(),
        contractDate:date + nth(date) +' of '+ month+' '+fortnightAway.getFullYear(),
        paymentMethod: '',
        canAfford: '',
        signedName: '',
        signedId:'',
        signature: '',
        bankName: '',
        bankBranch:'',
        bankHolder:'',
        bankAccount:'',
        bankCode:'',
        bankType:'',
        debitDate: '',
        debitMonth: '',
        debitAmount: '',
        premium: null,
        title: '',
        entryDate: '01/MM/YYYY',
        benIdNumber:'',
        benName:'',
        spouseName: '',
        spouseId: '',
        communicationLanguage:'',
        address: '',
        phone: '',
        email:'',
        age:'',
        dateOfBirth:'',
        idNumber:'',
        surname:'',
        firstname:'',
        bankAddress: '',
        bankAmount: '',
        bankContact: '',
        decemberDebit: '',



 });
 const [newBeneficiary, setBeneficiary] = React.useState({
   name: '',
   surname: '',
   idNo: '',
   age:'',
   relationship:'',
 })
 const {form: newBeneficiary2, setForm: setForm2, setInForm: setInForm2 } = useForm({
  name: '',
  surname: '',
  idNo: '',
  age:'',
  relationship:'',
  coverAmount: '',
  premium: '',
  coverIndex: '',
  mainPlanKey: null,
  mainCoverName: '',
})
 const [image, setImage] = React.useState('');
 const [file, setFile] = React.useState({});
 const [progress, setProgress] = React.useState(0);
 const [aploading, setAploading] = React.useState('');
 const [benList, setBenList] = React.useState([]);
 const [benList2, setBenList2] = React.useState([]);
 const [showAlert, setShowAlert] = React.useState(false);

  
  const resetState =  () => {
   setBeneficiary({
    name: '',
    idNo: '',
    age:'',
    relationship:'',
    fullBenefits: '',
    surname: '',
   })
  };

  
  const resetState2 =  () => {
    setForm2({
      name: '',
      surname: '',
      idNo: '',
      age:'',
      relationship:'',
      coverAmount: '',
      premium: 0,
      coverIndex: '',
      mainPlanKey: -1,
      mainCoverName: '',
    })
   };

  
const canAcceptBeneficiary = () => {
  if(!newBeneficiary.name || !newBeneficiary.surname || !newBeneficiary.idNo || !newBeneficiary.age || !newBeneficiary.relationship){
   return false;
  }
  return true;
}

const getTotalExtendedPremiums = () => {
  return sum(benList2.map(e => e.premium));
}

const canAcceptBeneficiary2 = () => {
  if(!newBeneficiary2.name  || !newBeneficiary2.idNo || !newBeneficiary2.age || !newBeneficiary2.relationship || !newBeneficiary2.coverAmount || !newBeneficiary2.premium){
   return false;
  }
  return true;
}

 const handleMusicChange = (key, value) => {

   if(key === 'idNumber' && value.length == 13 ){
    setInForm('dateOfBirth',DocHelpers.documentsHelper.getDateOfBirth(value) );
    setInForm('age', DocHelpers.documentsHelper.getAge(value));
   }
   if(key === 'spouseId' && value.length == 13 ){
    const age = DocHelpers.documentsHelper.getAge(value)
    if(age > Number(music.age) ){
      setInForm(key, "");
      return;
    }
   }

   if((key === 'idNumber' || key === 'spouseId') && value.length > 13 ){
     return;
   }
   if(key === "entryDate" && !value.includes('01')){
     return;
   }
  setInForm(key, value);
 }

 const handleBeneficiaryChange = (key, value) => {
  const mus = {...newBeneficiary};
  if(key === 'idNo' && value.length == 13 ){
    mus['age'] =  DocHelpers.documentsHelper.getAge(value);
   }
  mus[key] = value;
  setBeneficiary(mus);
}

const handleBeneficiaryChange2 = (key, value) => {
  if(key === 'idNo' && value.length == 13 ){
    setInForm2('age', DocHelpers.documentsHelper.getAge(value));
   }
 setInForm2(key, value);
}


//Document Builder 
function insertString(a, b, at)
{
    const length = at.length;
    var position = a.indexOf(at); 

    if (position !== -1)
    {
        position += length;
        return a.substr(0, position) +' '+ b + a.substr(position);    
    }  

    return a;
}
const list1Proto = "<tr><td></td> <td></td> <td></td> <td></td><td></td> </tr>";

const mainHTML =  `<!DOCTYPE html><html><head> <title>Nrand</title> <style>html{-webkit-print-color-adjust: exact;}body{width: 900px; padding-left: 40px; padding-right: 40px; font-family: Arial, Helvetica, sans-serif !important; font-size: 13px !important;}h4{text-align: center;}.sub-heading{text-align: center; color: rgb(221,52,47); font-weight: bolder;}.icon{width: 220px; height: 90px; margin-left: 70px;}.one{width: 200px; height: 25px; color: gray; margin-left: 70px; margin-top: 20px;}.text-center{text-align: center;}.span{color: rgb(221,52,47);}.spanline{padding-left: 5px; padding-right: 5px; border-bottom: 1px solid black;}.spandotted{padding-left: 5px; padding-right: 5px; border-bottom: 1px dotted black;}.two{color: gray; float: right; width: 480px; height: 40px;}.three{padding-left: 100px; padding-top: 20px;}.col1{background-color: rgb(221,52,47); width: 60%; height: 29px; color: white; padding-left: 5px; padding-top: 5px; border: 1px solid black;}.col2{background-color: rgb(221,52,47); width: 22%; height: 34px; color: white; border-right: 1px solid black; border-bottom: 1px solid black; border-top: 1px solid black;}.col3{background-color:rgb(221,52,47); width: 17%; height: 34px; border-bottom: 1px solid black; border-top: 1px solid black; border-right: 1px solid black;}.row1{display: flex;}.row2{display: flex}.col4{width: 65px; padding-left: 5px; padding-top: 5px; border-left: 1px solid black; border-right: 1px solid black; border-bottom: 1px solid black;}.col5{width: 55px; border-bottom: 1px solid black; border-right: 1px solid black; padding-left: 5px; padding-top: 5px;}.col6{width: 55px; border-bottom: 1px solid black; border-right: 1px solid black; padding-left: 5px; padding-top: 5px}.col7{width: 50px; border-bottom: 1px solid black; border-right: 1px solid black; padding-left: 5px; padding-top: 5px}.col8{width: 60px; border-bottom: 1px solid black; border-right: 1px solid black; padding-left: 5px; padding-top: 5px}.col9{width: 539px; border-bottom: 1px solid black; border-right: 1px solid black; padding-left: 5px; padding-top: 5px}.col10{width: 309px; border-bottom: 1px solid black; padding-left: 5px; padding-top: 5px}.col11{border-left: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black; padding-top: 5px; padding-left: 5px; width: 237px;}.row3{display: flex}.col12{border-left: 1px solid black; border-right: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-top: 5px; width: 309px;}.col13{border-bottom: 1px solid black; border-right: 1px solid black; width: 1102px;}.row4{display: flex}.col14{border-left: 1px solid black; border-right: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-top: 5px; width: 309px;}.col15{border-bottom: 1px solid black; border-right: 1px solid black; width: 1102px;}.row5{display: flex}.col16{border-left: 1px solid black; border-right: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-top: 5px; width: 309px;}.col17{border-bottom: 1px solid black; border-right: 1px solid black; width: 500px;}.col18{border-bottom: 1px solid black; border-right: 1px solid black; width: 60px; padding-left: 5px; padding-top: 5px}.col19{border-bottom: 1px solid black; border-right: 1px solid black; width: 535px;}.row6{display: flex}.col20{border-left: 1px solid black; border-right: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-top: 5px; width: 309px;}.col21{border-bottom: 1px solid black; border-right: 1px solid black; width: 500px;}.col22{border-bottom: 1px solid black; border-right: 1px solid black; width: 60px; padding-left: 5px; padding-top: 5px;}.col23{border-bottom: 1px solid black; border-right: 1px solid black; width: 535px;}.row7{display: flex}.col24{border-left: 1px solid black; border-right: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-top: 5px; width: 309px;}.col25{border-bottom: 1px solid black; border-right: 1px solid black; width: 1102px;}.row8{display: flex}.col26{border-left: 1px solid black; border-right: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-top: 5px; width: 309px;}.col27{border-bottom: 1px solid black; border-right: 1px solid black; width: 1102px;}.row9{display: flex}.col28{border-left: 1px solid black; border-right: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-top: 5px; width: 309px;}.col29{border-bottom: 1px solid black; border-right: 1px solid black; width: 1102px;}.row10{display: flex}.col30{border-left: 1px solid black; border-right: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-top: 5px; width: 309px;}.col31{border-bottom: 1px solid black; border-right: 1px solid black; width: 1102px;}.row11{display: flex}.col32{border-left: 1px solid black; border-right: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-top: 5px; width: 309px;}.col33{border-bottom: 1px solid black; border-right: 1px solid black; width: 1102px;}.row12{display: flex;}.col34{border-left: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black; padding-left: 5px; padding-top: 5px; width: 309px;}.col35{border-bottom: 1px solid black; border-right: 1px solid black; width: 520px;}.col36{border-bottom: 1px solid black; border-right: 1px solid black; padding-left: 5px; padding-top: 5px; width: 40px;}.col37{border-bottom: 1px solid black; border-right: 1px solid black; width: 535px;}.row13{display: flex;}.col38{border-bottom: 1px solid black; width: 309px; height: 21px; border-left: 1px solid black; border-right: 1px solid black; padding-left: 5px; padding-top: 5px;}.col39{border-bottom: 1px solid black; border-right: 1px solid black; height: 26px; width: 566px;}.col40{border-bottom: 1px solid black; border-right: 1px solid black; height: 26px; width: 535px;}.row14{height: 24px; width: 896px; background-color: rgb(221,52,47); color : white; padding-left: 4px; font-size: 14px !important; padding-top: 5px;}th{height: 38px; background-color: rgb(221,52,47); color : white; border: 1px solid black;}.table1{margin-top: 20px; border-collapse: collapse;}td{border: 1px solid black; height: 20px;}.table2{border-collapse: collapse; height: 22px; width:250px;}#tick{background-color: white; color: rgb(221,52,47); width: 100px;}.tables{display: flex; justify-content: space-between;}.top{background-color: rgb(221,52,47); color: white; text-align: center; height: 42px; width: 350px;}.bottom{display: flex; justify-content: space-between; padding: 2px;}.bank-details{width:350px; border: 1px solid black;}.left{border-left: 1px solid black; border-bottom: 1px solid black; margin-left: 35px; width: 214px;}.premium{width: 250px;}.sign1{margin-top: 50px; display: flex;}.line{width: 130px; border-bottom: 1px solid gray; margin-left: 10px;}.sign2{padding-top: 60px;}.line2{width: 200px; border-bottom: 1px solid gray; margin-left: 100px;}.sign3{margin-top: 20px;}.sign4{margin-top: 20px;}.par{border: 1px solid black; width: 450px; height: 90px; position: absolute; left: 950px; bottom: -800px;}strong{color: rgb(5, 81, 110);}.add{border: 1px solid black; height: 110px; width: 720px; margin-top: 50px; color: gray;}.first{display: flex; margin-top: 30px; justify-content: start; margin-bottom: 20px;}.yes{height: 20px; width: 33px; margin-left: 80px; text-align: center; border: 1px solid black; margin-top: 10px;}.no{height: 20px; width: 30px; text-align: center; border-right: 1px solid black; border-bottom: 1px solid black; border-top: 1px solid black;}.declare{margin-bottom: 20px;}.span-spacer{padding-left: 150px;}.acc-no{padding-top: 1px;}.span2{width: 200px;}.deduction{border-collapse: collapse; margin-top: 20px;}.authorise{margin-top: 20px;}.tables1{margin-bottom: 10px; border-collapse: collapse;}#name{background-color: rgba(211, 209, 209, 0.884); color: black;}.empty{display: flex; margin-left: 50px;}.nothing1{width: 600px; border-bottom: 1px solid black; margin-bottom: 17px; margin-left: 250px;}.nothing2{width: 600px; border-bottom: 1px solid black; margin-bottom: 17px; margin-left: 420px;}.nothing3{width: 600px; border-bottom: 1px solid black; margin-bottom: 17px; margin-left: 440px;}.nothing4{width: 600px; border-bottom: 1px solid black; margin-bottom: 17px; margin-left: 360px;}.nothing5{width: 600px; border-bottom: 1px solid black; margin-bottom: 17px; margin-left: 365px;}.nothing6{margin-left: 370px; margin-top: 10px;}.nothing7{width: 600px; border-bottom: 1px solid black; margin-bottom: 17px; margin-left: 410px;}.nothing8{width: 600px; border-bottom: 1px solid black; margin-bottom: 17px; margin-left: 440px;}.nothing9{width: 600px; border-bottom: 1px solid black; margin-bottom: 17px; margin-left: 535px;}.nothing10{margin-bottom: 17px; margin-left: 170px;}.office{height: 140px; width: 400px; border: 2px solid black; margin-left: 65px; margin-top: 50px;}</style></head><body > <h4>MEMBERSHIP APPLICATION</h4> <p class="sub-heading">NRand Cash-Assist Cover</p><div class="icon"> <img alt="icon" width="170px" height="80px" src="https://firebasestorage.googleapis.com/v0/b/nrand-docs.appspot.com/o/NRAND_NEW_MOTTO-1-removebg-preview.png?alt=media&token=8f785dc1-7aff-4cc8-89b7-a079d8ff2103"/> </div><div class="one"> Your Grief <span class=".span">|</span> Our Concern </div><div class="two"> <p>NRand Brokers cc - FSP No. 35408 is an Authorised Financial Service Provider. Terms and Condition apply.</p></div><div class="three"> <p>FSP 35408</p></div><div class="row1"> <div class="col1">Main Member Details</div><div class="col2"></div><div class="col3"></div></div><div class="row2"> <div class="col4">Title:</div><div class="col5" id="title"></div><div class="col6"></div><div class="col7"></div><div class="col8"></div><div class="col9"></div><div class="col10" style="font-weight: bold;">Cover Amount</div><div class="col11" style="font-weight: bold;" id="coverAmount"></div></div><div class="row3"> <div class="col12">Surname:</div><div class="col13" id="surname"></div></div><div class="row4"> <div class="col14">First Name:</div><div class="col15" id="firstname"></div></div><div class="row5"> <div class="col16">ID No:</div><div class="col17" id="idNumber"></div><div class="col18">Age:</div><div class="col19" id="age"></div></div><div class="row6"> <div class="col20">Date Of Birth:</div><div class="col21" id="dateOfBirth"></div><div class="col22"></div><div class="col23"></div></div><div class="row7"> <div class="col24">Address:</div><div class="col25" id="address"></div></div><div class="row8"> <div class="col26">Email Address:</div><div class="col27" id="email"></div></div><div class="row9"> <div class="col28">Tel / Cell No:</div><div class="col29" id="phone"></div></div><div class="row10"> <div class="col30">Preferred language of communication:</div><div class="col31" id="communicationLanguage"></div></div><div class="row11"> <div class="col32">Entry date:</div><div class="col33" id="entryDate"></div></div><div class="row12"> <div class="col34">Name of beneficiary & ID No:</div><div class="col35" id="benName"></div><div class="col36">ID:</div><div class="col37" id="benIdNumber"></div></div><div class="row12"> <div class="col34">Spouse Name & ID No:</div><div class="col35" id="spouseName"></div><div class="col36">ID:</div><div class="col37" id="spouseId"></div></div><div class="row14"> Dependent / childrens' Details 0 -21 years (26 years*) </div><table class="tables1"> <thead> <tr> <th id="name" width="313px" color="gray">Name</th> <th id="name" width="340px">Surname</th> <th id="name" width="260px">Relationship</th> <th id="name"width="390px">Date of Birth / ID No</th> <th id="name" width="100px">Age</th> </tr></thead> <tbody id="list1"> </tbody> </table> <table class="tables1"> <thead> <tr> <th class="" width="340px">NAME AND SURNAME OF EXTENDED FAMILY</th> <th width="300px">IDENTITY NUMBER / DATE OF BIRTH</th> <th width="100px">AGE</th> <th width="175px">RELATIONSHIP</th> <th width="175px">COVER AMOUNT</th> <th width="175px">PREMIUM</th> </tr></thead> <tbody id="list2"> </tbody> </table><div class="tables"> <table class="table2"> <thead> <tr> <th width="300px">PAYMENT METHOD</th> <th class=" text-center" id="tick">TICK</th> </tr></thead> <tbody> <tr> <td id="paymentMethod"></td><td class=" text-center" >X</td></tr></tbody> </table> <div class="bank-details"> <div class="top">OUR BANK DETAILS</div><div class="bottom"> <div class=""> <p>Acc Name:</p><p>Bank:</p><p>Account No:</p><p>Branch Name:</p><p>Branch Code:</p><p>Your Ref</p></div><div class=""> <p>NRand Funerals</p><p>First National Bank</p><p>62 6 49 72 61 90</p><p>Rosebank</p><p>253 305</p><p>Policy NUmber</p></div></div></div><div class="premium"> <table class="table2"> <thead> <tr> <th width="170px" style="border-right:1px solid rgb(221,52,47);">PREMIUM CALCULATION</th> <th class="text-center" style="border-left: 1px solid rgb(221,52,47);" width="80px" > SUMMARY</th> </tr></thead> <tbody> <tr> <td id="paymentMethod">Main Member Premium</td><td class=" text-center" id="premium"></td></tr><tr> <td id="paymentMethod">Extended Family Premiums</td><td class=" text-center" id="exPremium"></td></tr><tr> <td id="paymentMethod" style="font-weight: bold;">TOTAL PREMIUM DUE</td><td class=" text-center" style="font-weight: bold;" id="totalPremium"></td></tr></tbody> </table> </div></div><div class="add"> <p>Head Office: Office 13, 3rd Floor Marble Towers, 208-212 Jeppe Street, Johannesburg</p><p>Thohoyandou: Office B3, Sabina Plaza, 93 Mphephu Drive l Louistrichardt: No 4. Ackerman Centre, Cnr. Rissik & Kruger Street</p><p>Reg No: 2008/099277/23 Tel: +27 11 974 7950 Fax: 086 6044 327 Email: <strong>info@nrandfunerals.co.za</strong></p></div><div class="first"> <p >I CAN AFFORD PREMIUMS FOR THIS POLICY</p><div class="yes" id="canAfford"></div></div><div class="declare"> Authority and Mandate for payments Instruction: Electronic and Written Mandates </div><div class="bank-name">Given by (name of Accountholder): <span class="span-spacer"></span><span class="spandotted" id="bankHolder"></span> <br/> Address: <span style="padding-left: 299px;"></span><span class="spandotted" id="bankAddress"></span> <br/> Bank : <span style="padding-left: 313px;"></span><span class="spandotted" id="bankName"></span> <br/> Branch and Code: <span style="padding-left: 245px;"></span><span class="spandotted" id="bankBranch"></span> </div><div class="acc-no"> Account Number: <span style="padding-left: 250px;"></span><span class="spandotted" id="bankAccount"></span> <br/> Type of Account: <span style="padding-left: 254px;"></span><span class="spandotted" id="bankType"></span> <br/> Amount: <span style="padding-left: 302px;"></span><span class="spandotted" id="debitAmount"></span> <br/> Date: <span style="padding-left: 319px;"></span><span class="spandotted" id="debitDate"></span> <br/> Contact Number: <span style="padding-left: 252px;"></span><span class="spandotted" id="bankContact"></span> <br/> Abbreviated Name as Registered with the Bank: <span style="padding-left:69px;"></span><span class="spandotted" >NRAND</span></div><br/> <div class="authorise"> <p>This signed Authority and Mandate refers to our contract dated <span class="spanline" id="contractDate"></span> (“the Agreement”).</p><p>I / We hereby authorise you to issue and deliver payment instructions to your Banker for collection against my / our abovementioned account at my / our above-mentioned Bank (or any other bank or branch to which I / we may transfer my / our account) on condition that the sum of such payment instructions will never exceed my / our obligations as agreed to in the Agreement and commencing on <span class="spanline" id="entryDate2"></span> and continuing until this Authority and Mandate is terminated by me / us by giving you notice in writing of not less than 20 ordinary working days, and sent by prepaid registered post or delivered to your address as indicated above.</p><p>The individual payment instructions so authorised to be issued must be issued and delivered as follows: monthly.</p><p>In the event that the payment day falls on a Sunday, or recognised South African public holiday, the payment day will automatically be the preceding ordinary business day.</p><p>Payment Instructions due in December may be debited against my account on <span class="spanline" id="decemberDebit"></span> </p><p>I / We understand that the withdrawals hereby authorized will be processed through a computerized system provided by the South African Banks and I also understand that details of each withdrawal will be printed on my bank statement. Each transaction will contain a number, which must be included in the said payment instruction and if provided to you should enable you to identify the Agreement. A payment reference is added to this form before the issuing of any payment instruction.</p><h5>MANDATE</h5> <p>I / We acknowledge that all payment instructions issued by you shall be treated by my / our aove mentioned bank as if the instructions had been issued by me/ us personally.</p><h5>CANCELLATION</h5> <p>I / We agree that although this Authorityand Mandate may be cancelled by me / us, such cancellation will not cancel the Agrrement. I / We shall not be entitled to any refund of amounts which you have withdrawn while authority was in force, if such amounts were legally owing to you.</p><h5>ASSIGNMENT</h5> <p>I / We acknowledge that this Authority may be ceded to or assigned to a third party if the agreement is also ceded or assigned to that third party,but in the absence of such assihnment of the agreement, this Authority and Mandate cannot be assigned to any third party.</p><p>Signed at <span class="spanline" id="signedAt2"></span> on this <span class="spanline" id="sgnedDay2"></span> day of <span class="spanline" id="signedmonth2"></span></p><p>SIGNATURE <span class="spanline" id="signature2"></span> (AS USED FOR SIGNING CHEQUES OR CREDIT CARD VOUCHERS)</p><p>NAME & SURNAME <span class="spanline" id="signedName2"></span> ID NO <span class="spanline" id="signedId2"></span> </p></div><div><h4>TERMS & CONDITION</h4><ol> <li>This application form is my application for cash assist cover by NRand on behalf of KGA Life Ltd.</li><li>I,the person mentioned as the main member, hereby apply for membership at NRand Cash Assist.</li><li>The policy owner must pay the premium or anybody nominated by the policy owner as set out on the depit order instruction.</li><li>For natural death, cover is subject to six (6) calender months waiting period for benefits, 30 days for un-natural (Accidental)death and 2 years for main member suicide. One (1) month for children younger than 14 years. Twelve (12) calender months for members between 70-90 years.</li><li>Cover will commence after the stipulated waiting period has expired.</li><li>Cover is subject to a once-off entry fee of <span class="span2">R100</span> payable with your first instalment.</li><li>I understand that false infomation can lead to the cancellation of this policy, that premiums will be forteited and no claims will be paid.</li><li>I confirm that as at the date of this application form, no one on this appplication is suffering from or being treated for any chronic illness, if not kindly provide the brief explanation and medical report for our consideration.</li><li>I authorise NRand Brokers / KGA Life obtail from any doctor, or any other person, any necessary medical information.</li><li>I fully understand all the benefits, premiums, covers amount, terms and conditions of this group scheme. I further confirm that i have not and will not receive any money, and / or payback from agent who assisted me with this application.</li></ol><div class="authorise1"> <p>NAME & SURNAME <span class="spanline" id="signedName"></span> ID NO <span class="spanline" id="signedId"></span></p><p>SIGNATURE <span class="spanline" id="signature"></span> </p></div><div class="office"> <p>FOR OFFICE USE</p><p>Checked by............................................................</p><p>Confirm by............................................................</p><p>Policy no............................................................</p></div><div class="authorise2"> <p>I THE AGENT CONFIRM YHAT I HAVE EXPLAINED IN FULL, POLICY TERMS,CONDITIONS AND BENEFITS OF NRAND CASH ASSIST COVER TO THE CLIENT. I FURTHER CONFIRM THAT I HAVE NOT AND WILL NOT OFFER ANY MONEY / PAYBACK TO THENCLIENT IN ORDER TO PERSUDE THE CLIENT IN TAKING THIS POLICY. IF THE ABOVE IS NOT TRUE, I AGREE AND CONFIRM THAT I WILL BE LEGALLY LIABLE TO NRAND BROKERS AND THE MEMBER FOR ANY LOSS OR DAMAGE SUFFERED.</p></div><div class="authorise1"> <p>AGENT NAME..............................................................................ID NO.......................................................................................... <br/> MOBILE NO...............................</p><p>AGENT SIGNATURE...........................................................................................................</p></div><h4>GENERAL TERMS & CONDITIONS</h4><h3 id="terms">GENERAL TERMS & CONDITIONS</h3><h4>Underwritten by KGA life Limited (Reg. No. 1998/023657/06</h4><h4>A registered insurer and authorised financial services provider, FSP No. 15980</h4><ol> <li>This is funeral Scheme</li><li>Premiums are payable monthly in advance on or befoe the 1st day of each month. Only 15 days grace period for late payment is allowed. More than 15 days late payment means <span class="span2">No Cover</span> for the following 30 days after payment has been received by NRand. (this means you will have 30 days waiting period).</li><li>Cover for the scheme is provided on a month-to-month basis and no reserves are built up under the scheme.</li><li>Premiums under the scheme are not guaranteed and cannot be adjusted by Nrand Brokers cc / KGA Life with 30 days' written notice</li><li>Participation is open to any healthy person between the age of 18 up to and including 90 years on conditon that the prosoective policyholder (and his / her dependants / extended family members) meet all the entry requirement as determined by NRand brokers cc KGA Life of in order to qualify for funeral insuarance. </li><li>The entry date of the assurance of a member and his / her dependants / extended family members is on the 1st day of a month following the acceptance by NRand Brokers cc / KGA life of the member's application form and payment of the first premium.</li><li>Cover will start afrer the waiting period has expired, as specified in the Master Policy.</li><li>When member increases his / her cover under the scheme the increased cover amount will be subjected to the relevant waiting eriod before the increased cover starts.</li><li>If a member's cover ceases and a member applies to re-join the scheme at a later stage the same conditions as for a new membership will apply.</li><li>The foolowing standard waiting periods apply to new members joining the group scheme: <ul> <li>Natural causes: Six (6) calender months for members of all ages, unnatural (Accidental) causes:1 month and twelve (12) calender months for members between the ages of 75 and 90 years.</li><li>suicide/ attempted suicide: Twenty four (24) calender month (only applicable to the ain member).</li></ul> </li><li>Not receiving a confirmation of payment{receipt in terms of Section 47 of the Long-Term Insuarance Act (LTA)}from the peron or scheme collecting / receivong the premium in any given month,will serve as a notice of non-payment in terms of Section 52(1) of the LTA and such policy will lapsewithout a notice.In the event that premium is received at a later stage, i.e two (2) months later, waiting period stated under 10 above will apply. </li><li>A member who is not legally married can stilll enjoy family cover as long as all the relevant information is given on the application form at inception.</li><li>A child is covered as follows: <ol type="a"> <li>If unmarried and under the age of 21 years</li><li>If unmarried, under the age of 26 years and a full time student at a recognised education instruction.</li><li>If physically or mentaly disable, who does not receive a grant and who is dependent on his / her parents.</li></ol> </li><li>A dependent foster child approved by KGA Life shall mean: <ol type="a"> <li>Legally adopted with the relevant court order or other legal documentation issued or a member who is caring for the child of direct family permanately who cannot care for the child or a child not direct family, if documentation can be supplied by the walfare department that the member is caring for the permanately.</li></ol> </li><li>Claims <ol type="a"> <li>No valid claims will be paid if premiums or parts of premiums are outstanding or arrers.No premiums received No cover.</li><li>Only claims submitted within three (3) or six (6) months of the date of death will be considered for payment.</li><li>No claims will be considered unless documentary evidence , as determined by NRand Brokres cc / KGA Life, has been supplied.</li><li>If the Master policy provides for a pro-rata claim payment in instances where death was due to a dreaded disease, the family of the beneficiary will have six (6) months , from the date of death, in which to provide documentary evidence that the cause of death was not as a results of a dreaded disease, whereupon the balance of the cover amount will be paid out to the family / beneficiary.</li><li>Claims for common-law spuses who were not declined on the origional applicaton form or afterward the entitled date with an amendment form, will not be consired for payment in the event of death (traditional and civil marriages included).</li></ol> </li><li>The calculation of the claim benefit: The Spouse and children aged 14 and older qualify for the full cover amount, children under 6 years or age qualify for 25% of the cover amount and children age 6 to 13 years qualify 50% of the cover amount.</li><li>The following documents are required when claiming: <ol type="a"> <li>Certified copy of deceased’s ID book, stamped “deceased”</li><li>Certified copy of death certificate</li><li>DHA1663 Form / Notification of death</li><li>DHA 1680 Form / Declaration letter by traditional leader (if applicable)</li><li>Certified copy of beneficiary’s ID</li><li>Bank letter confirming beneficiary’s bank account</li><li>Proof of premium payments</li></ol> </li><li id="lastly">When in doubt, please ask now to avoid misunderstanding at the claim's stage.</li></ol> </div></body></html>`;
const getFinder = (id) => {return `id="${id}">`};

const getBeneficiaries = (benList) => {
let ht = "";
benList.map(e => {
  const list1Proto = "<tr><td>"+e.name+"</td> <td>"+e.surname+"</td> <td>"+e.relationship+"</td> <td>"+e.idNo+"</td><td>"+e.age+"</td> </tr>";
  ht += list1Proto;
})
return ht;
}

const getBeneficiaries2 = (benList) => {
  let ht = "";
  benList2.map(e => {
    const list1Proto = "<tr><td>"+e.name+"</td> <td>"+e.idNo+"</td> <td>"+e.age+"</td> <td>"+e.relationship+"</td><td>"+e.coverAmount+"</td><td>R"+e.premium+"</td> </tr>";
    ht += list1Proto;
  })
  return ht;
  }

const duplicates = {
  signedAt: ['signedAt2'],
  sgnedDay: ['sgnedDay2'],
  signedmonth: ['signedmonth2'],
  debitDate: ['debitDate3', 'debitDate2'],
  entryDate: ['entryDate2'],
  signedName:['signedName2'],
  signedId: ['signedId2'],
  signature: ['signature2'],
  premium: ['premium2'],
  address: ['bankAddress'],
  phone: ['bankContact'],


}

const generateHtml = React.useCallback(() => {
 let htmlFile = mainHTML;
 const saveMusic  = {...music};
 saveMusic.premium  ='R '+ music.premium;
 saveMusic.exPremium  ='R '+ Number(getTotalExtendedPremiums());
 saveMusic.totalPremium ='R '+ (Number(getTotalExtendedPremiums()) +Number(music.premium));
 saveMusic.debitAmount ='R '+ (Number(getTotalExtendedPremiums()) +Number(music.premium));
 Object.keys(saveMusic)
 .map(key => {
   const value = saveMusic[key];
   const finder = getFinder(key);
    htmlFile = insertString(htmlFile, value ,finder) ;
    if(duplicates[key]){
      duplicates[key].map(key2 => {
        const finder2 = getFinder(key2);
        htmlFile = insertString(htmlFile, value ,finder2);
      })
    }
 })
 const beneficiaries =  getBeneficiaries(benList);
 const finder = getFinder('list1');
 htmlFile = insertString(htmlFile, beneficiaries ,finder);
 // extended 
 const beneficiaries2 =  getBeneficiaries2(benList2);
 const finder2 = getFinder('list2');
 htmlFile = insertString(htmlFile, beneficiaries2 ,finder2);
 return http.prototype.addNewMusic2({...music,file: htmlFile, createdAt: new Date()})
    .then(id => {
      Swal.fire({
        title: 'Thank You!',
        text: "Your Information is captured and we'll be in contact soon",
        icon: 'success'
      })
     setTimeout(()=> {
       window.location.href = 'https://nrandfunerals.co.za/'; 
     }, 3000);
     
    })
  
},[music, benList])





const handleCover1Select = React.useCallback((event) => {
  const index = Number(event.target.value);
  handleMusicChange('coverAmount',premiumAmounts[index]);
  handleMusicChange('premium',mainCoverList[index]);
  handleMusicChange('coverIndex',index);
  
},[ premiumAmounts, mainCoverList]);

const handleCover2Select = React.useCallback((event) => {
  const index = Number(event.target.value);
  handleBeneficiaryChange2('coverAmount',premiumAmounts[index]);
  handleBeneficiaryChange2('premium',mainCoverList2[index]);
  handleBeneficiaryChange2('coverIndex',index);
  
},[ premiumAmounts, mainCoverList2]);

function canBeSubmitted(){
  if(!music.phone || !music.idNumber || !music.surname || !music.firstname || !music.spouseId || music.idNumber.length < 10 ){
    return false;
  }
  return true;
}

  return (
    <div >
    <Card classes={classes.textCenter} >
    <CardHeader color="primary" >New Membership - Cash-Assist Cover </CardHeader>
    <CardBody>
    <Avatar src={icon} style={{width:170,height:80}} variant="square" />

    <Box width="100%" height={40}  style={{background: "linear-gradient(40deg, #DD342F, rgba(221,52,47,0.8))",marginTop:25, marginBottom:10,paddingTop:8,paddingLeft:5}} color="primary">
      <p  style={{color:'white',fontWeight:"bold", fontSize: 17}}>Main Member Details</p>
    </Box>
   
<GridContainer>
<GridItem xs={12} sm={12} md={5}>
<CustomInput
labelText="ID No"
formControlProps={{
  fullWidth: true
}}
inputProps={{
  onChange: (event) => {
   handleMusicChange('idNumber',event.target.value);
  },
  value: music.idNumber
}}
/>
</GridItem>
<GridItem xs={12} sm={12} md={5}>
<CustomInput
labelText="Date Of Birth"
formControlProps={{
  fullWidth: true,
}}
inputProps={{
  onChange: (event) => {
   handleMusicChange('dateOfBirth',event.target.value);
  },
  value: music.dateOfBirth
}}
/>
</GridItem>
<GridItem xs={12} sm={12} md={1}>
<CustomInput
labelText="Age"
disabled={true}
formControlProps={{
  fullWidth: true,
}}
inputProps={{
  onChange: (event) => {
   handleMusicChange('age',Number(event.target.value));
  },
  value: music.age
}}
/>
</GridItem>
<GridItem xs={12} sm={12} md={10}>
<NativeSelect
color="primary"
style={{width:'100%',marginTop:26}}
disabled={!music.age}
value={music.mainPlanKey}
title="Title"
onChange={(event) => {
  const index = Number(event.target.value);
  handleMusicChange('mainPlanKey',index);
  setMainCoverList(Premiums[index].prices);
  handleMusicChange('mainCoverName',Premiums[index].name);
  handleMusicChange('coverAmount',null);
  handleMusicChange('premium', null);
  handleMusicChange('coverIndex',-1);
}}
inputProps={{
  name: 'Select Main Member Plan',
  id: 'age-native-helper',
}}
>
<option defaultValue value="" > Select Main Member Plan Type</option>
{Premiums.filter(e => Number(music.age) >=  e.min  &&  Number(music.age) <= e.max).map((e,key) => <option key={key} value={(Number(e.key) -1)} >{e.key}. {e.name}</option>)}
</NativeSelect>

</GridItem>

<GridItem xs={12} sm={12} md={5}>
<NativeSelect
color="primary"
style={{width:'100%',marginTop:26}}
value={music.title}
title="Title"
onChange={(event) => {
  handleMusicChange('title',event.target.value);
}}
inputProps={{
  name: 'Select Title',
  id: 'age-native-helper',
}}
>
<option defaultValue value="" >Select Title</option>
{['MS','MR', 'MRS', 'REV'].map(e => <option key={e} value={e} >{e}</option>)}
</NativeSelect>

</GridItem>
<GridItem xs={12} sm={12} md={5}>
<NativeSelect
color="primary"
style={{width:'100%',marginTop:26}}
disabled={!music.age}
value={music.coverIndex}
onChange={(event) => {
handleCover1Select(event);
}}
inputProps={{
  name: 'Cover Amount',
  id: 'age-native-helper',
}}
>
<option defaultValue value="" >Select Cover Amount</option>
{(mainCoverList || []).map((e, index) => <option key={index} value={index} >{premiumAmounts[index]}</option>)}
</NativeSelect>

</GridItem>

<GridItem xs={12} sm={12} md={5}>
<CustomInput
labelText="First Name"
formControlProps={{
  fullWidth: true
}}
inputProps={{
  onChange: (event) => {
   handleMusicChange('firstname',event.target.value);
  },
  value: music.firstname
}}
/>
</GridItem>
<GridItem xs={12} sm={12} md={5}>
<CustomInput
labelText="Surname"
formControlProps={{
  fullWidth: true
}}
inputProps={{
  onChange: (event) => {
   handleMusicChange('surname',event.target.value);
  },
  value: music.surname
}}
/>
</GridItem>
<GridItem xs={12} sm={12} md={5}>
<CustomInput
labelText="Email address"
formControlProps={{
  fullWidth: true
}}
inputProps={{
  onChange: (event) => {
   handleMusicChange('email',event.target.value);
  },
  value: music.email
}}
/>
</GridItem>
<GridItem xs={12} sm={12} md={5}>
<CustomInput
labelText="Tel / Cell No"
formControlProps={{
  fullWidth: true
}}
inputProps={{
  onChange: (event) => {
   handleMusicChange('phone',event.target.value);
  },
  value: music.phone
}}
/>
</GridItem>
<GridItem xs={12} sm={12} md={10}>
<CustomInput
labelText="Address"
formControlProps={{
  fullWidth: true
}}
inputProps={{
  onChange: (event) => {
   handleMusicChange('address',event.target.value);
  },
  value: music.address
}}
/>
</GridItem>
<GridItem xs={12} sm={12} md={5}>
<CustomInput
labelText="Preferred language of communication"
formControlProps={{
  fullWidth: true
}}
inputProps={{
  onChange: (event) => {
   handleMusicChange('communicationLanguage',event.target.value);
  },
  value: music.communicationLanguage
}}
/>
</GridItem>
<GridItem xs={12} sm={12} md={5}>
<CustomInput
labelText="Entry Date"
formControlProps={{
  fullWidth: true
}}
inputProps={{
  onChange: (event) => {
   handleMusicChange('entryDate',event.target.value);
  },
  value: music.entryDate
}}
/>
</GridItem>
<GridItem xs={12} sm={12} md={5}>
<CustomInput
labelText="Name of beneficiary"
formControlProps={{
  fullWidth: true
}}
inputProps={{
  onChange: (event) => {
   handleMusicChange('benName',event.target.value);
  },
  value: music.benName
}}
/>
</GridItem>
<GridItem xs={12} sm={12} md={5}>
<CustomInput
labelText="Beneficiary ID no"
formControlProps={{ fullWidth: true}}
inputProps={{
  onChange: (event) => {
   handleMusicChange('benIdNumber',event.target.value);
  },
  value: music.benIdNumber
}}
/>
</GridItem>
<GridItem xs={12} sm={12} md={5}>
<CustomInput
labelText="Name of Spouse"
formControlProps={{
  fullWidth: true
}}
inputProps={{
  onChange: (event) => {
   handleMusicChange('spouseName',event.target.value);
  },
  value: music.spouseName
}}
/>
</GridItem>
<GridItem xs={12} sm={12} md={5}>
<CustomInput
labelText="Spouce ID no"
formControlProps={{ fullWidth: true}}
inputProps={{
  onChange: (event) => {
   handleMusicChange('spouseId',event.target.value);
  },
  value: music.spouseId
}}
/>
</GridItem>
<GridItem xs={12} sm={12} md={12}>
<Box width="100%" height={40}  style={{background: "linear-gradient(40deg, #DD342F, rgba(221,52,47,0.8))",marginTop:25, marginBottom:10,paddingTop:8,paddingLeft:5}} color="primary">
      <p  style={{color:'white',fontWeight:"bold", fontSize: 17}}>Dependent / Children’s Details 0-21 years (26 years*)</p>
    </Box>
</GridItem>
<GridItem xs={12} sm={12} md={12}>
<p style={{color:"gray"}}>
</p>
</GridItem>

<GridItem xs={12} sm={12} md={10}>
  <TableContainer component={Paper}>
  <Table >
  <TableHead className={classes.tablehead}>
    <TableRow>
 <TableCell className={classes.table}>NAME</TableCell>
 <TableCell className={classes.table}>SURNAME</TableCell>
 <TableCell className={classes.table}>RELATIONSHIP</TableCell>
 <TableCell  className={classes.table} >ID NUMBER/DATE OF BIRTH</TableCell>
 <TableCell  className={classes.table} >AGE</TableCell>

 </TableRow>
  </TableHead>
  <TableBody>
   {benList.map((row,key) => <TableRow key={key}>
  <TableCell className={classes.table2}>{row.name}</TableCell>
  <TableCell className={classes.table2}>{row.surname}</TableCell>
  <TableCell className={classes.table2}>{row.relationship}</TableCell>
 <TableCell className={classes.table2}>{row.idNo}</TableCell>
 <TableCell className={classes.table2}>{row.age}</TableCell>

   </TableRow>)}
  </TableBody>
</Table>
</TableContainer>
</GridItem>
<GridItem xs={12} sm={12} md={3}>
<CustomInput
labelText="NAME"
formControlProps={{ fullWidth: true}}
inputProps={{
  onChange: (event) => { handleBeneficiaryChange('name',event.target.value);
  },value: newBeneficiary.name
}} />
</GridItem>
<GridItem xs={12} sm={12} md={3}>
<CustomInput
labelText="SURNAME"
formControlProps={{ fullWidth: true}}
inputProps={{
  onChange: (event) => { handleBeneficiaryChange('surname',event.target.value);
  },value: newBeneficiary.surname
}} />
</GridItem>
<GridItem xs={12} sm={12} md={5}>
<CustomInput
labelText="ID NUMBER/DATE OF BIRTH"
formControlProps={{ fullWidth: true}}
inputProps={{
  onChange: (event) => { handleBeneficiaryChange('idNo',event.target.value);
  },value: newBeneficiary.idNo
}} />
</GridItem>
<GridItem xs={12} sm={12} md={2}>
<CustomInput
labelText="Age"
formControlProps={{ fullWidth: true}}
inputProps={{
  onChange: (event) => { handleBeneficiaryChange('age',event.target.value);
  },value: newBeneficiary.age
}} />
</GridItem>
<GridItem xs={12} sm={12} md={3}>
<CustomInput
labelText="Relationship"
formControlProps={{ fullWidth: true}}
inputProps={{
  onChange: (event) => { handleBeneficiaryChange('relationship',event.target.value);
  },value: newBeneficiary.relationship
}} />
</GridItem>
<GridItem xs={12} sm={12} md={2}>
 <Button 
style={{marginTop:18}}
disabled={!canAcceptBeneficiary()} onClick={()=> {
  const newben = benList.concat([newBeneficiary]);
  console.log('newben', newben);
  setBenList(newben);
  resetState();
}} color="primary">Add Beneficiary</Button>
</GridItem>



<GridItem xs={12} sm={12} md={12}>
<Box width="100%" height={40}  style={{background: "linear-gradient(40deg, #DD342F, rgba(221,52,47,0.8))",marginTop:25, marginBottom:10,paddingTop:8,paddingLeft:5}} color="primary">
      <p  style={{color:'white',fontWeight:"bold", fontSize: 17}}>Extended Family Details</p>
    </Box>
</GridItem>
<GridItem xs={12} sm={12} md={12}>
<p style={{color:"gray"}}>
</p>
</GridItem>

<GridItem xs={12} sm={12} md={10}>
  <TableContainer component={Paper}>
  <Table >
  <TableHead className={classes.tablehead}>
    <TableRow>
 <TableCell className={classes.table}>NAME & SURNAME OF EXTENDED FAMILY</TableCell>
 <TableCell className={classes.table}>IDENTITY NUMBER / DATE OF BIRTH</TableCell>
 <TableCell className={classes.table}>AGE</TableCell>
 <TableCell className={classes.table}>RELATIONSHIP</TableCell>
 <TableCell className={classes.table}>COVER AMOUNT</TableCell>
 <TableCell className={classes.table}>PREMIUM</TableCell>
 </TableRow>
  </TableHead>
  <TableBody>
   {benList2.map((row,key) => <TableRow key={key}>
  <TableCell className={classes.table2}>{row.name}</TableCell>
 <TableCell className={classes.table2}>{row.idNo}</TableCell>
 <TableCell className={classes.table2}>{row.age}</TableCell>
 <TableCell className={classes.table2}>{row.relationship}</TableCell>
 <TableCell className={classes.table2}>{row.coverAmount}</TableCell>
 <TableCell className={classes.table2}>{'R'+row.premium}</TableCell>
   </TableRow>)}
  </TableBody>
</Table>
</TableContainer>
</GridItem>
<GridItem xs={12} sm={12} md={3}>
<CustomInput
labelText="NAME & SURNAME"
formControlProps={{ fullWidth: true}}
inputProps={{
  onChange: (event) => { handleBeneficiaryChange2('name',event.target.value);
  },value: newBeneficiary2.name
}} />
</GridItem>
<GridItem xs={12} sm={12} md={5}>
<CustomInput
labelText="ID NUMBER/DATE OF BIRTH"
formControlProps={{ fullWidth: true}}
inputProps={{
  onChange: (event) => { handleBeneficiaryChange2('idNo',event.target.value);
  },value: newBeneficiary2.idNo
}} />
</GridItem>
<GridItem xs={12} sm={12} md={2}>
<CustomInput
labelText="Age"
formControlProps={{ fullWidth: true}}
inputProps={{
  onChange: (event) => { handleBeneficiaryChange2('age',Number(event.target.value));
  },value: newBeneficiary2.age
}} />
</GridItem>

<GridItem xs={12} sm={12} md={7}>
<NativeSelect
color="primary"
style={{width:'100%',marginTop:26}}
value={newBeneficiary2.mainPlanKey}
title="Title"
onChange={(event) => {
  const index = Number(event.target.value);
  handleBeneficiaryChange2('mainPlanKey',index);
  setMainCoverList2(Premiums[index].prices);
  handleBeneficiaryChange2('mainCoverName',Premiums[index].name);
  handleBeneficiaryChange2('coverAmount',null);
  handleBeneficiaryChange2('premium', null);
  handleBeneficiaryChange2('coverIndex',-1);
}}
inputProps={{
  name: 'Select Extended Member Plan',
  id: 'age-native-helper',
}}
>
<option defaultValue value="" > Select Extended Member Plan Type</option>
{Premiums.filter(e => Number(newBeneficiary2.age) >=  e.min  &&  Number(newBeneficiary2.age) <= e.max).map((e,key) => <option key={key} value={(Number(e.key) -1)} >{key}. {e.name}</option>)}
</NativeSelect>

</GridItem>

<GridItem xs={12} sm={12} md={3}>
<NativeSelect
color="primary"
style={{width:'100%',marginTop:26}}
value={newBeneficiary2.coverIndex}
onChange={(event) => {
handleCover2Select(event);
}}
inputProps={{
  name: 'Cover Amount',
  id: 'age-native-helper',
}}
>
<option defaultValue value="" >Select Cover Amount</option>
{(mainCoverList2 || []).map((e, index) => <option key={index} value={index} >{premiumAmounts[index]}</option>)}
</NativeSelect>

</GridItem>
<GridItem xs={12} sm={12} md={3}>
<CustomInput
labelText="Relationship"
formControlProps={{ fullWidth: true}}
inputProps={{
  onChange: (event) => { handleBeneficiaryChange2('relationship',event.target.value);
  },value: newBeneficiary2.relationship
}} />
</GridItem>

<GridItem xs={12} sm={12} md={2}>
 <Button 
style={{marginTop:18}}
disabled={!canAcceptBeneficiary2()} onClick={()=> {
  const newben = benList2.concat([newBeneficiary2]);
  setBenList2(newben);
  resetState2();
}} color="primary">Add Extended Family</Button>
</GridItem>


<GridItem xs={12} sm={12} md={12}>
<Box width="100%" height={55}  style={{background: "linear-gradient(40deg, #DD342F, rgba(221,52,47,0.9))",marginTop:25, marginBottom:10,paddingTop:12,paddingLeft:5, borderRadius: 30}} color="primary">
<p style={{color:"white" ,fontWeight: 'bold' , fontSize: 25, paddingLeft:5, }}>
  Main Member Premium:R{Number(music.premium)} <span style={{paddingLeft:40}}></span>  Extended Family Premiums:R{ getTotalExtendedPremiums()} <span style={{paddingLeft:40}}></span>  Premium Due: R{Number(getTotalExtendedPremiums()) +Number(music.premium) }
</p>
    </Box>
</GridItem>



<GridItem xs={12} sm={12} md={12}>
<Box width="100%" height={40}  style={{background: "linear-gradient(40deg, #DD342F, rgba(221,52,47,0.8))",marginTop:25, marginBottom:10,paddingTop:8,paddingLeft:5}} color="primary">
      <p  style={{color:'white',fontWeight:"bold", fontSize: 17}}>Declaration</p>
    </Box>
</GridItem>


<GridItem xs={12} sm={12} md={12}>
<p style={{color:"gray" ,fontWeight: 'light' , fontSize: 13}}>
OUR BANK DETAILS <br/> Acc Name: NRand Funerals. Bank: First National Bank. Account No: 62 649 726 190. Branch Name: Rosebank.   Branch Code: 253305.  Your Ref: Policy Number  
</p>
</GridItem>



<GridItem xs={12} sm={12} md={4}>
What is your Payment Method? 
<NativeSelect
color="primary"
style={{width:'100%',marginTop:7, marginBottom:20}}
value={music.paymentMethod}
onChange={(event) => {
  handleMusicChange('paymentMethod',(event.target.value))
}}
>
<option value={''} >Select Payment Method</option>
{["Sassa paying point","NRand Office", "Debit order","Cash deposit", "EFT"].map(e => <option key={e} value={e} >{e}</option>)}
</NativeSelect>
</GridItem>

<GridItem xs={12} sm={12} md={4}>
  Can you afford this Premium ? 
<NativeSelect
color="primary"
style={{width:'100%',marginTop:7, marginBottom:20}}
value={music.canAfford}
onChange={(event) => {
  handleMusicChange('canAfford',(event.target.value))
}}
>
<option value={''} >I CAN AFFORD PREMIUMS FOR THIS POLICY</option>
{["Yes","No"].map(e => <option key={e} value={e} >{e}</option>)}
</NativeSelect>
</GridItem>


<GridItem xs={12} sm={12} md={12}>
<p style={{color:"gray" , fontSize: 13}}>
Signed at <span style={{borderBottom:'2px solid gray', fontWeight: 'normal',paddingLeft:5,paddingRight:5}}>{music.signedAt}</span> on this <span style={{borderBottom:'2px solid gray', fontWeight: 'normal',paddingLeft:5,paddingRight:5}}>{music.sgnedDay}</span>  day of <span style={{borderBottom:'2px solid gray',  fontWeight: 'normal',paddingLeft:5,paddingRight:5}}>{music.signedmonth}</span>
</p>
</GridItem>

<GridItem xs={12} sm={12} md={3}>
<CustomInput
labelText="Signature/ initials and surname"
formControlProps={{ fullWidth: true}}
inputProps={{
  onChange: (event) => { handleMusicChange('signature',event.target.value);
  },value: music.signature
}} />
</GridItem>
<GridItem xs={12} sm={12} md={3}>
<CustomInput
labelText="Name & Surname"
formControlProps={{ fullWidth: true}}
inputProps={{
  onChange: (event) => { handleMusicChange('signedName',event.target.value);
  },value: music.signedName
}} />
</GridItem>
<GridItem xs={12} sm={12} md={3}>
<CustomInput
labelText="ID NO"
formControlProps={{ fullWidth: true}}
inputProps={{
  onChange: (event) => { handleMusicChange('signedId',event.target.value);
  },value: music.signedId
}} />
</GridItem>

{music.paymentMethod === 'Debit order' && <GridItem xs={12} sm={12} md={10}>
<p style={{color:"gray" ,fontWeight: 'light' , fontSize: 13}}>
I, THE PERSON MENTIONED AS THE MAIN MEMBER OR PREMIUM PAYER, HEREBY APPLY FOR MEMBERSHIP OF NRAND CASH-ASSIST PLAN IN ACCORDANCE WITH THE TERMS AND CONDITIONS WHICH I HAVE READ AND UNDERSTOOD AS SET OUT HEREIN. I WISH TO PAY MY MONTHLY PREMIUMS AS FOLLOWS:
</p>
</GridItem>}

{music.paymentMethod === 'Debit order' && <GridItem xs={12} sm={12} md={3}>
<CustomInput
labelText="Bank Name"
formControlProps={{ fullWidth: true}}
inputProps={{
  onChange: (event) => { handleMusicChange('bankName',event.target.value);
  },value: music.bankName
}} />
</GridItem>}

{music.paymentMethod === 'Debit order' && <GridItem xs={12} sm={12} md={3}>
<CustomInput
labelText="Branch Name and Code"
formControlProps={{ fullWidth: true}}
inputProps={{
  onChange: (event) => { handleMusicChange('bankBranch',event.target.value);
  },value: music.bankBranch
}} />
</GridItem>}
{music.paymentMethod === 'Debit order' && <GridItem xs={12} sm={12} md={4}>
<CustomInput
labelText="Account Holder"
formControlProps={{ fullWidth: true}}
inputProps={{
  onChange: (event) => { handleMusicChange('bankHolder',event.target.value);
  },value: music.bankHolder
}} />
</GridItem>}

{music.paymentMethod === 'Debit order' && <GridItem xs={12} sm={12} md={3}>
<CustomInput
labelText="Account No"
formControlProps={{ fullWidth: true}}
inputProps={{
  onChange: (event) => { handleMusicChange('bankAccount',event.target.value);
  },value: music.bankAccount
}} />
</GridItem>}
{music.paymentMethod === 'Debit order' && <GridItem xs={12} sm={12} md={3}>
<CustomInput
labelText="Type of Account"
formControlProps={{ fullWidth: true}}
inputProps={{
  onChange: (event) => { handleMusicChange('bankType',event.target.value);
  },value: music.bankType
}} />
</GridItem>}


{music.paymentMethod === 'Debit order' && <GridItem xs={12} sm={12} md={10}>
<p style={{color:"gray" ,fontWeight: 'light' , fontSize: 13}}>
I authorize NRand Brokers to debit my account on this <span style={{borderBottom:'2px solid gray', fontWeight: 'bolder', paddingLeft:5,paddingRight:5}}>{music.debitDate}</span> day of each month with the amount of R <span style={{borderBottom:'2px solid gray', fontWeight: 'bold',paddingLeft:5,paddingRight:5}}>{getTotalExtendedPremiums() +Number(music.premium)}</span>  per month and additional <span style={{fontWeight:'bold'}}>R100</span> ONCE OFF FEE in the 1st month for administration purposes. Should the relevant premium be adjusted by the Institution as a result of a general decrease/increase in premium, I confirm that the adjusted premium (including stamps duty) may be deducted from my bank account, until such time as I cancel this authorisation in writing or until I substitute it with a new authorisation.
</p>
</GridItem>}

{music.paymentMethod === 'Debit order' && <GridItem xs={12} sm={12} md={3}>
Deduction Date 
<NativeSelect
color="primary"
style={{width:'100%',marginTop:7, marginBottom:20}}
value={music.debitDate}
onChange={(event) => {
  handleMusicChange('debitDate',(event.target.value))
}}
>
<option value={''} >Select Date</option>
{["1st","7th","15th","25th","LDM"].map(e => <option key={e} value={e} >{e}</option>)}
</NativeSelect>
</GridItem>}

{music.paymentMethod === 'Debit order' && <GridItem xs={12} sm={12} md={3}>
  Deduction Month
<NativeSelect
color="primary"
style={{width:'100%',marginTop:7, marginBottom:20}}
value={music.debitMonth}
onChange={(event) => {
  handleMusicChange('debitMonth',(event.target.value))
}}
>
<option value={''} >Select Month</option>
{["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"].map(e => <option key={e} value={e} >{e}</option>)}
</NativeSelect>
</GridItem>}



<GridItem xs={12} sm={12} md={12}>
<Box width="100%" height={40}  style={{background: "linear-gradient(40deg, #DD342F, rgba(221,52,47,0.8))",marginTop:25, marginBottom:10,paddingTop:8,paddingLeft:5}} color="primary">
      <p  style={{color:'white',fontWeight:"bold", fontSize: 17}}>Agreement</p>
    </Box>
</GridItem>

{music.paymentMethod === 'Debit order' && <GridItem xs={12} sm={12} md={10}>
<p style={{color:"gray" ,fontWeight: 'light' , fontSize: 13}}>
This signed Authority and Mandate refers to our contract as dated as on signature hereof ("the Agreement"). I / We hereby authorise you to issue and deliver payment instructions to the bank for collection against my / our abovementioned account at my / our above mentioned bank (or any other bank or branch to which I / We may transfer my / our account) on condition that the sum of such payment instructions will never exceed my / our obligations as agreed to in the Agreement, and commencing on the commencement date and continuing until this Authority and Mandate is terminated by me / us by giving you notice in writing of no less than 20 ordinary working days, and sent by prepaid registered post or delivered to your address indicated above.<br/><br/>
The individual payment instructions so authorised to be issued must be issued and delivered as follows:<br/><br/>
I On the <span style={{borderBottom:'2px solid gray', fontWeight: 'bolder', paddingLeft:5,paddingRight:5}}>{music.debitDate}</span>  day ("payment day") of each and every month commencing on <span style={{borderBottom:'2px solid gray', fontWeight: 'bolder', paddingLeft:5,paddingRight:5}}>{music.entryDate}</span> . In the event that the payment day falls on a Saturday, Sunday or recognized South African public holiday, the payment day will automatically be the very next ordinary business day. Further, if there are insufficient funds in the nominated account to meet the obligation, you are entitled to track my account and re- present the instruction for payment as soon as sufficient funds are available in my account.
<br/><br/>ii. Monthly; on or after the dates when the obligation in terms of the Agreement is due and the amount of each individual payment instruction may not be more or less that the obligation due;
<br/><br/>I / We understand that the withdrawals hereby authorised will be processed through a computerized system provided by the South African Banks and I also understand that details of each withdrawal will be printed on my bank statement. Each transaction will contain a number, which must be included in the said payment instruction and if provided to you should enable you to identify the Agreement. A payment reference is added to this form before the issuing of any payment instruction. I / We shall not be entitled to any refund of amounts which you have withdrawn while this authority was in force, if such amounts were legally owing to NRand Brokers.
</p>
</GridItem>}

<GridItem xs={12} sm={12} md={10}>
<p style={{color:"gray" ,fontWeight: 'light' , fontSize: 13}}>
  MANDATE <br/> 
I / We acknowledge that all payment instructions issued by you shall be treated by my/our above mentioned bank as if the instructions had been issued by me/us personally.
<br/><br/> CANCELLATION  <br/> 
I / We agree that although this Authority and Mandate may be cancelled by me / us, such cancellation will not cancel the Agreement. I / We shall not be entitled to any refund of amounts which you have withdrawn while this authority was in force, if such amounts were legally owing to you.
<br/><br/> ASSIGNMENT  <br/> 
I / We acknowledge that this Authority may be ceded to or assigned to a third party if the agreement is also ceded or assigned to that third party, but in the absence of such assignment of the Agreement, this Authority and Mandate cannot be assigned to any third party.

</p>
</GridItem>



<GridItem xs={12} sm={12} md={10}>
<p style={{color:"gray" ,fontWeight: 'normal' , fontSize: 13}}>
<br/><br/> TERMS & CONDITIONS <br/> <br/>
1. This application form is my application for cash assist cover by NRand on behalf of KGA Life Ltd.<br/>
2. I, the person mentioned as the main member, hereby apply for membership at NRand Cash Assist.<br/>
3. The policy owner must pay the premium or anybody nominated by the policy owner as set out on the debit order instruction.<br/>
4. For natural death, cover is subject to six (6) calendar months waiting period for benefits, 30 days for un-natural (Accidental) death and 2<br/>
years for main member suicide. One (1) month for children younger than 14 years. Twelve (12) calendar months for members between
75-90 years.<br/>
5. Cover will commence after the stipulated waiting period has expired.<br/>
6. Cover is subject to a once-off entry fee of R100.00 payable with your first instalment.<br/>
7. I understand that false information can lead to the cancellation of this policy, that premiums will be forfeited and that no claims will be
paid.<br/>
8. I confirm that as at the date of this application form, no one on this application is suffering from or being treated for any chronic illness,
if not kindly provide brief explanation and medical report for our consideration.<br/>
9. I authorize NRand Brokers / KGA Life to obtain from any doctor, or any other person, any necessary medical information.<br/>
10. I fully understand all the benefits, premiums, cover amount, terms and conditions of this group scheme. I further confirm that I have
not and will not receive any money, and/or payback from the agent who assisted me with this application.<br/>
</p>
</GridItem>

<GridItem xs={12} sm={12} md={10}>
<p style={{color:"gray" ,fontWeight: 'normal' , fontSize: 13}}>
<br/><br/> GENERAL TERMS & CONDITIONS<br/> 
 Underwritten by KGA Life Limited (Reg. No. 1998/023657/06<br/>
A registered insurer and authorised financial services provider, FSP No. 15980<br/> <br/>
1. This is a funeral scheme.<br/>
2. Premiums are payable monthly in advance on or before the 1st day of each month. Only 15 days grace period for late
payment / arrears is allowed. More than 15 days late payment / arrears means No Cover for the following 30 days after
payment has been received by NRand. (this means you will have 30 days waiting period).<br/>
3. Cover for the scheme is provided on a month-to-month basis and no reserves are built up under the scheme.<br/>
4. Premiums under the scheme are not guaranteed and can be adjusted by NRand Brokers cc / KGA Life with 30 days’
written notice.<br/>
5. Participation is open to any healthy person between the ages of 18 up to and including 90 years on condition that the
prospective policyholder (and his/her dependants/ extended family members) meet all the entry requirements as determined
by NRand Brokers cc / KGA Life in order to qualify for funeral insurance.<br/>
6. The entry date of the assurance of a member and his/her dependants / extended family members is on the 1st day of a
month following the acceptance by NRand Brokers cc / KGA Life of the member’s application form and payment of the first
premium.<br/>
7. Cover will start after the waiting period has expired, as specified in the Master Policy.<br/>
8. When a member increases his/her cover under the scheme the increased cover amount will be subject to the relevant
waiting period before the increased cover starts.<br/>
9. If a member’s cover ceases and the member applies to re-join the scheme at a later stage the same conditions as for a new
membership will apply.<br/>
10. The following standard waiting periods apply to new members joining the group scheme:<br/>
 Natural causes: Six (6) calendar months for members of all ages, Unnatural (Accidental) causes: 1 month and
twelve (12) calendar months for members between the ages of 75 and 90 years.<br/>
 Suicide/ attempted suicide: Twenty four (24) calendar months (only applicable to the main member).<br/><br/>
11. Not receiving a confirmation of payment (receipt in terms of Section 47 of the Long-Term Insurance Act (LTA)) from
the person or scheme collecting/receiving the premium in any given month, will serve as a notice of non-payment in terms of
Section 52(1) of the LTA and such policy will lapse without a notice. In the event that premium is received at a later stage,
i.e two (2) months later, waiting period stated under 10 above will apply.<br/>
12. A member who is not legally married can still enjoy family cover as long as all the relevant information is given on the
application form at inception.<br/>
13. A child is covered as follows:<br/>
a) If unmarried and under the age of 21 years.<br/>
b) If unmarried, under the age of 26 years and a full time student at a recognized education institution.<br/>
c) If physically or mentally disabled, who does not receive a grant, and who is dependent on his/her parents.<br/><br/>
14. A dependent foster child approved by KGA Life shall mean:<br/>
a) Legally adopted with the relevant court order or other legal documentation issued or a member who is caring for the child
of direct family permanently who cannot care for the child or a child not direct family, if documentation can be supplied by
the welfare department that the member is caring for the permanently.<br/><br/>
15. Claims:<br/>
a) No valid claims will be paid if premiums or parts of premiums are outstanding or in arrears. No premium received No
cover.<br/>
b) Only claims submitted within three (3) to six (6) months of the date of death will be considered for payment.<br/>
c) No claims will be considered unless documentary evidence, as determined by NRand Brokers cc / KGA Life, has been
supplied.<br/>
d) If the Master Policy provides for a pro-rata claim payment in instances where death was due to a dreaded disease, the
family or the beneficiary will have six (6) months, from the date of death, in which to provide documentary evidence that the
cause of death was not as a result of a dreaded disease, whereupon the balance of the cover amount will be paid out to the
family/beneficiary.<br/>
e) Claims for common-law spouses who were not declared on the original application form or afterward the entry date with
an amendment form, will not be considered for payment in the event of death (traditional and civil marriages included).<br/><br/>
16. The calculation of the claim benefit: The spouse and children aged 14 years and older qualify for the full cover amount,
children under 6 years of age qualify for 25% of the cover amount and children aged 6 to 13 years qualify for 50% of the
cover amount.<br/>
17. The following documents are required when claiming:<br/>
a) Certified copy of deceased’s ID book, stamped “deceased”<br/>
b) Certified copy of death certificate<br/>
c) DHA1663 Form / Notification of death<br/>
d) DHA 1680 Form / Declaration letter by traditional leader (if applicable)<br/>
e) Certified copy of beneficiary’s ID<br/>
f) Bank letter confirming beneficiary’s bank account<br/>
g) Proof of premium payments<br/><br/>
17. When in doubt, please ask now to avoid misunderstanding at the claim's stage.<br/>
</p>
</GridItem>


<GridItem xs={12} sm={12} md={12}>
<br />
{aploading && <h6>{aploading}</h6>}
{aploading && <BorderLinearProgress variant="determinate" color="primary" value={progress} />}

<br />
<Button disabled={!canBeSubmitted()} onClick={()=> {generateHtml()}} color="primary">Accept And Register</Button>
</GridItem>
<GridItem xs={12} sm={12} md={12}>
{canBeSubmitted() ?<p style={{color:"green"}}>
  You can now submit this form after reading and understainding our terms and conditions
</p>: <p style={{color:"red"}}>
Make sure all required fields are filled and correct before submitting <br/>
{!music.idNumber && <span>* ID Number  <br/></span>}
{!music.phone && <span>* Phone Number <br/></span>}
{(!music.firstname || !music.surname) && <span>* Name & Surname  <br/></span>}
{!music.spouseId && <span>* Spouce ID Number  <br/></span>}
{music.idNumber && music.idNumber.length < 10 && <span>* ID Number must be 13 digits long <br/></span>}
</p>}
</GridItem>
<GridItem xs={12} sm={12} md={12}>
<p style={{color:"gray"}}>
NRand Brokers cc - FSP No. 35408 is an Authorised Financial Services Provider. Terms and Conditions apply.
</p>
</GridItem>
</GridContainer>


    </CardBody>
  </Card>
      </div>
  );
}
